export const BLUEJACKETEER_LINK = process.env.REACT_APP_BLUEJACKETEER_LINK;
export const SENTRY_URL = process.env.REACT_APP_SENTRY_URL;
